<template>
  <div >
    <!-- <AddOrUpPage v-if="ifImport==0 && tablePageInfo.importPageId>0" v-show="!isPreview" :ref="'questionImport'" :initPageInfo="{'tableId':tablePageInfo.tableId,'pageId':tablePageInfo.importPageId,'pageType':7,'initMainDataId':questionId}">
    </AddOrUpPage> -->
    <el-form ref="questionForm" style="background-color: white;" :model="questionInfo" label-width="130px" label-suffix=":">
      <el-row  type="flex" style="flex-wrap:wrap;"
        v-if="!isPreview"
      >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item  label="业务题型" prop="eqWorkType" :rules="[
              { required: true, message: '必须填写', trigger: ['blur', 'change'] }
            ]">
            <el-select
              v-model="questionInfo.eqWorkType" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
              @change="eqWorkTypeChange"
            >
                <el-option
                    v-for="dicItem in workTypeList"
                    :key="dicItem.DIC_ID"
                    :label="dicItem.DIC_NAME"
                    :value="dicItem.DIC_ID">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <el-form-item  label="题型" prop="eqType" :rules="[
              { required: true, message: '必须填写', trigger: ['blur', 'change'] }
            ]">
            <el-select
              v-model="questionInfo.eqType" clearable
              :disabled="showType == 0?false:true"
              :multiple="false"
              @change="eqTypeChange"
            >
                <el-option
                    v-for="dicItem in eqTypeList"
                    :key="dicItem.DIC_ID"
                    :label="dicItem.DIC_NAME"
                    :value="dicItem.DIC_ID"
                    :disabled="dicItem.disabled">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col 
          :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
        >
          <el-button type="primary" @click="openSetDialog(1)">附件设置</el-button>
          <el-button type="primary" @click="openSetDialog(2)">前置页面设置</el-button>
          <el-button type="primary" @click="openSetDialog(3)">样式设置</el-button>
          <el-button v-if="questionInfo.eqType == 16" type="primary" @click="openSetDialog(4)">多题选择设置</el-button>
          <!-- <el-button type="primary" @click="changePreview" >
            <span v-if="isPreview">编辑</span>
            <span v-else>预览</span>
          </el-button> -->
        </el-col>
        <!-- 如果是阅读题 显示做题形式 -->
        <el-col
          :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-show="questionInfo.eqType==9?true:false"
        >
          <el-form-item  label="做题形式" >
            <el-select
              v-model="questionInfo.ZD_DO_WAY" clearable
              
            >
              <el-option label="每次一道" value="1"></el-option>
              <el-option label="全部显示" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <!-- 如果是子题 则显示托福阅读题的特殊的 段落和单词的选择 -->
        <el-col v-if="ifChild == 1 && (parentQuestionInfo.sectionArr && parentQuestionInfo.sectionArr.length > 0)"
          :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
        >
          <el-form-item  label="关联段落" >
            <el-select
              v-model="questionInfo.sectionNum" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              multiple
              @change="testChange"
            >
                <el-option
                    v-for="dicItem in parentQuestionInfo.sectionArr"
                    :key="dicItem"
                    :label="'段落'+dicItem"
                    :value="dicItem">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="ifChild == 1 && (parentQuestionInfo.heigthArr && parentQuestionInfo.heigthArr.length > 0)"
          :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
        >
          <el-form-item  label="关联单词" >
            <el-select
              v-model="questionInfo.heightDc" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              multiple
            >
                <el-option
                    v-for="(dicItem,index) in parentQuestionInfo.heigthArr"
                    :key="index"
                    :label="dicItem.substring(0,30)"
                    :value="dicItem">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col v-if="questionInfo.eqType == 7"
          :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
        >
          <el-form-item  label="答案附件类型" prop="eqAnswerIfFile">
            <el-select
              v-model="questionInfo.eqAnswerIfFile" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="false"
              @change="questionInfo.prevSet.preparatTime;questionInfo.prevSet.recordTime;"
            >
                <el-option
                    v-for="dicItem in eqContentIfFileList"
                    :key="dicItem.DIC_ID"
                    :label="dicItem.DIC_NAME"
                    :value="dicItem.DIC_ID"
                    :disabled="dicItem.disabled">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8"
          v-if="questionInfo.eqAnswerIfFile == 3"
        >
          <el-form-item  label="录制时长" >
            <el-input placeholder="秒" style="width:150px;" v-model="questionInfo.prevSet.preparatTime">
              <template slot="prepend">准备:</template>
            </el-input>
            <el-input placeholder="秒" style="width:150px;" v-model="questionInfo.prevSet.recordTime">
              <template slot="prepend">作答:</template>
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item  label="试题题目" prop="eqContent" :rules="[
              { required: true, message: '必须填写', trigger: ['change', 'change'] }
            ]">
            <el-tooltip  effect="dark" :content="eqContentTip" placement="bottom">
              <vue-ueditor-wrap ref="myTextEditor" v-model="questionInfo.eqContent" :key="1"
                @beforeInit="addCustomButtom"
                :disabled="(showType == 0 || showType == 1)?false:true"
                @contentChange="ueditorSelectionChange"
              ></vue-ueditor-wrap>
            </el-tooltip>
          </el-form-item>
        </el-col>

        <!-- 阅读题子题 插入填空类型 要插入的内容 -->
        <el-col v-if="ifChild == 1 && (questionInfo.eqType == 15)"
          :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
        >
          <el-form-item  label="插入内容" >
            <el-input
              v-model="questionInfo.eqInsertContent"
              suffix-icon="el-icon-document"
              :disabled="(showType == 0 || showType == 1)?false:true"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
          v-if="questionInfo.eqType==1 || questionInfo.eqType==2 || questionInfo.eqType==8 || questionInfo.eqType==16"
        >
          <el-form-item  label="试题选项" prop="eqOption" :rules="[
              { required: true, message: '必须填写', trigger: ['blur', 'change'] }
            ]">
              <span slot="label"  >试题选项:
                <el-button type="primary" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickAddEqOption()"
                    icon="el-icon-plus"
                    circle
                >
                    <!-- [{{addOrUpData[fieldSetOne.inputFName]}}]  -->
                </el-button>
              </span>
              <el-row v-for="(eqOptionOne,eqOptionIndex) in questionInfo.eqOption" :key="'eqOption_'+eqOptionIndex">
                <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                  {{zmArr[eqOptionIndex]}}:
                </el-col>
                <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                  <!-- <el-input v-model="questionInfo.eqOption[eqOptionIndex]"
                    suffix-icon="el-icon-document"
                    :disabled="(showType == 0 || showType == 1)?false:true"
                    type="text"
                  >
                  </el-input> -->
                  <vue-ueditor-wrap ref="eqOption" v-model="questionInfo.eqOption[eqOptionIndex]" :config="UEditorSampleConfig"
                    :disabled="(showType == 0 || showType == 1)?false:true"
                  ></vue-ueditor-wrap>
                </el-col>
                <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                  <el-button type="danger" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickDeleteEqOption(eqOptionIndex)"
                    icon="el-icon-delete"
                    circle
                  >
                  </el-button>
                </el-col>
              </el-row>
          </el-form-item>
        </el-col>
        <!-- 匹配题的 选项和答案 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
          v-if="questionInfo.eqType==10"
        >
          <el-form-item  label="匹配选项" prop="eqOption" :rules="[
              { required: true, message: '必须填写', trigger: ['blur', 'change'] }
            ]">
              <span slot="label"  >匹配选项:
                <el-button type="primary" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickAddEqOption()"
                    icon="el-icon-plus"
                    circle
                >
                    <!-- [{{addOrUpData[fieldSetOne.inputFName]}}]  -->
                </el-button>
              </span>
              <el-row v-for="(eqOptionOne,eqOptionIndex) in questionInfo.eqOption" :key="'eqOption_'+eqOptionIndex">
                <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
                  <el-row>
                    <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
                      <el-input v-model="questionInfo.eqOption[eqOptionIndex]"
                        :disabled="(showType == 0 || showType == 1)?false:true"
                        type="text"
                      >
                        <template slot="prepend">{{eqOptionIndex+1}}: </template>
                      </el-input>
                    </el-col>
                    <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                      <el-select
                        v-model="questionInfo.eqAnswer[eqOptionIndex]" clearable
                        :disabled="(showType == 0 || showType == 1)?false:true"
                        :multiple="false"
                      >
                          <el-option
                              v-for="(eqOptionOne,pptIndex) in questionInfo.eqOption1" :key="pptIndex"
                              :label="zmArr[pptIndex]"
                              :value="pptIndex+''">
                          </el-option>
                      </el-select>
                    </el-col>
                    <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
                      <el-input v-model="questionInfo.eqOption1[eqOptionIndex]"
                        :disabled="(showType == 0 || showType == 1)?false:true"
                        type="text"
                      >
                        <template slot="prepend">{{zmArr[eqOptionIndex]}}:  </template>
                      </el-input>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
                  <el-button type="danger" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickDeleteEqOption(eqOptionIndex)"
                    icon="el-icon-delete"
                    circle
                  >
                  </el-button>
                </el-col>
              </el-row>
          </el-form-item>
        </el-col>
        <!-- 长难句 增加答案选项 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
          v-if="questionInfo.eqType==14"
        >
          <el-form-item  label="答案选项" prop="eqOption" :rules="[
            { required: true, message: '必须填写', trigger: ['blur', 'change'] }
          ]">
              <span slot="label"  >答案选项:
                <el-button type="primary" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickAddEqOption()"
                    icon="el-icon-plus"
                    circle
                >
                    <!-- [{{addOrUpData[fieldSetOne.inputFName]}}]  -->
                </el-button>
              </span>
              <el-row v-for="(eqOptionOne,eqOptionIndex) in questionInfo.eqOption" :key="'eqOption_'+eqOptionIndex+'_'+eqOptionOne">
                <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
                  {{eqOptionIndex+1}}:
                </el-col>
                <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20">
                  <!-- 选择修饰类型 -->
                  <el-select
                    v-model="questionInfo.eqOption[eqOptionIndex]" clearable
                    :disabled="(showType == 0 || showType == 1)?false:true"
                    :multiple="false"
                  >
                      <el-option
                          v-for="(dicItem,cnjIndex) in cnjAnswerType" :key="cnjIndex"
                          :label="dicItem.DIC_NAME"
                          :value="dicItem.DIC_ID+''">
                      </el-option>
                  </el-select>
                  <!-- 对应的答案信息 -->
                  <el-input v-model="questionInfo.eqAnswer[eqOptionIndex]"
                    suffix-icon="el-icon-document"
                    :disabled="(showType == 0 || showType == 1)?false:true"
                    type="text"
                    class="add_or_up_input"
                  >
                  </el-input>
                  <el-input v-model="questionInfo.eqAnswer1[eqOptionIndex]"
                    v-show="questionInfo.eqOption[eqOptionIndex]>=7"
                    suffix-icon="el-icon-document"
                    :disabled="(showType == 0 || showType == 1)?false:true"
                    type="text"
                    class="add_or_up_input"
                  >
                  </el-input>
                </el-col>
                <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                  <el-button type="danger" size="small" v-if="(showType == 0 || showType == 1)"
                    @click="clickDeleteEqOption(eqOptionIndex)"
                    icon="el-icon-delete"
                    circle
                  >
                  </el-button>
                </el-col>
              </el-row>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
          v-if="questionInfo.eqType != 9 && questionInfo.eqType != 10 && questionInfo.eqType != 14 && questionInfo.eqType != 16"
        >
          <el-form-item  label="答案" prop="eqAnswer" :rules="[
              { required: true, message: '必须填写', trigger: ['blur', 'change'] }
            ]">
            <!-- 单选多选题 -->
            <el-select v-if="questionInfo.eqType==1 || questionInfo.eqType==2 || questionInfo.eqType==15 || questionInfo.eqType==8"
              v-model="questionInfo.eqAnswer" clearable
              :disabled="(showType == 0 || showType == 1)?false:true"
              :multiple="(questionInfo.eqType==2||questionInfo.eqType==8)?true:false"
            >
                <el-option
                    v-for="(dicItem,answerIndex) in questionInfo.eqOption.length" :key="answerIndex"
                    :label="zmArr[(answerIndex)]"
                    :value="answerIndex+''">
                </el-option>
            </el-select>
            <!-- 对错题 -->
            <el-radio-group v-else-if="questionInfo.eqType==3"
              v-model="questionInfo.eqAnswer" size="small"
            >
              <el-radio v-for="(eqOptionOne,answerIndex) in questionInfo.eqOption" :key="answerIndex"
                    :label="answerIndex+''" border>{{eqOptionOne}}</el-radio>
            </el-radio-group>
            <!-- 填空题 -->
            <div v-else-if="questionInfo.eqType==4">
              <el-row  type="flex" style="flex-wrap:wrap;" >
                <el-col :xs="24" :sm="24" :md="8" :lg="6" :xl="3">
                  <el-input v-model="questionInfo.eqAnswerInitIndex">
                    <template slot="prepend">初始下标</template>
                  </el-input>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8" :lg="6" :xl="3"
                  v-for="(eqAnswerOne,answerIndex) in questionInfo.eqAnswer" :key="answerIndex"
                >
                  <el-input v-model="questionInfo.eqAnswer[answerIndex]">
                    <template slot="prepend">{{answerIndex+1}}:</template>
                  </el-input>
                </el-col>
              </el-row>
            </div>
            <!-- 简答题的答案框 -->
            <div v-else-if="questionInfo.eqType == 7">
              <el-input
                v-model="questionInfo.eqAnswer"
                suffix-icon="el-icon-document"
                :disabled="(showType == 0 || showType == 1)?false:true"
                type="textarea"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-col>
        <!-- 简答题 -->
        <el-col v-if="questionInfo.eqType == 7 && questionInfo.eqAnswerIfFile == 2"
          :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
        >
          <el-form-item  label="答案音视频" prop="eqAnswerFile">
            <!-- :accept="fieldSetOne.docType" -->
            <el-upload
              class="upload-demo"
              :with-credentials="true"
              :action="'/'+GLOBAL.projectName+'/servlet/OmFileUploadServlet'"
              :on-success="(response, file, fileList)=> successFile(response, file, fileList,1)"
              :on-remove="(file, fileList)=> removeFile(file, fileList,1)"
              :on-exceed="(files, fileList)=> exceedFile(files, fileList,1)"
              :list-type="'text'"
              :limit="5"
              :file-list="questionInfo.eqAnswerFile"
            >
              <el-button slot="trigger" size="small" type="primary"
              >点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                  只能上传图片(jpg/png)/音频(mp3)/视频文件(mp4/m3u8/flv)格式
              </div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="questionInfo.eqType==7">
          <el-form-item  label="答题说明" prop="eqRemark" >
            <vue-ueditor-wrap ref="myRemarkEditor" v-model="questionInfo.eqRemark" 
                :disabled="(showType == 0 || showType == 1)?false:true" :config="UEditorSampleConfig"
              ></vue-ueditor-wrap>
          </el-form-item>
        </el-col>

        <!-- 阅读题 进行子题新增功能 -->
        <el-col v-if="questionInfo.eqType == 9"
          :xs="24" :sm="24" :md="24" :lg="24" :xl="24"
        >
          <el-form-item  label="试题" prop="eqQuestion">
             <!-- :rules="[
            { required: true, message: '必须填写', trigger: ['blur', 'change'] }
          ]" -->
            <span slot="label"  >新增试题:
              <el-button type="primary" size="small" v-if="(showType == 0 || showType == 1)"
                  @click="clickAddQuestion()"
                  icon="el-icon-plus"
                  circle
              >
                  <!-- [{{addOrUpData[fieldSetOne.inputFName]}}]  -->
              </el-button>
            </span>
            <el-row v-for="(questionOne,questionIndex) in questionInfo.childQuestionArr" :key="'childQuestion_'+questionOne">
              <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                <!--  -->
                <el-form-item :prop="'childQuestionScoreArr.' + questionIndex" :rules="[
                  { required: true, message: '必须填写', trigger: ['blur', 'change'] }
                ]">
                  <el-input v-model="questionInfo.childQuestionScoreArr[questionIndex]"
                    style="width:200px;"
                    :disabled="(showType == 0 || showType == 1)?false:true"
                  >
                    <template slot="prepend">分数</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15">
                <!-- -->
                <DoQuestion :initQuestionId="questionOne*1" :initShowType=2 :ifOperaRow=0
                      :questionIndex="questionIndex"
                ></DoQuestion> 
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <el-button type="primary" size="small"  v-if="(showType == 0 || showType == 1)"
                  @click="upDownChildQuestion(questionIndex,1)"
                  icon="el-icon-top" 
                  circle>
                </el-button>
                 <el-button type="primary" size="small"  v-if="(showType == 0 || showType == 1)"
                  @click="upDownChildQuestion(questionIndex,2)"
                  icon="el-icon-bottom" 
                  circle>
                </el-button>
                <el-button type="primary" size="small"  v-if="(showType == 0 || showType == 1)"
                  @click="clickUpdateQuestion(questionIndex)"
                  icon="el-icon-edit" 
                  circle>
                </el-button>
                <el-button type="danger" size="small" v-if="(showType == 0 || showType == 1)"
                  @click="clickDeleteQuestion(questionIndex)"
                  icon="el-icon-delete"
                  circle
                >
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item  label="题目解析" prop="eqResolve">
            <el-input v-model="questionInfo.eqResolve"
              suffix-icon="el-icon-document"
              :disabled="(showType == 0 || showType == 1)?false:true"
              type="textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-else>
        <DoQuestion :initQuestionInfo="questionInfo" :initShowType=3 :ifOperaRow=0
              :questionIndex=0
        ></DoQuestion>
      </el-row>

      <!-- <el-row v-if="showType != 2">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"  >
          <div class="BtnBox">
            <el-button type="primary" @click="checkQuestion" v-if="showType==0"
              :loading="fullscreenLoading"
            >
              保存
            </el-button>
            <el-button type="primary" @click="checkQuestion" v-if="showType==1"
              :loading="fullscreenLoading"
            >
              修改
            </el-button>
            <el-button @click="cancelPage" >取消</el-button>
            <el-button type="primary" @click="changePreview" >
              <span v-if="isPreview">编辑</span>
              <span v-else>预览</span>
            </el-button>
          </div>
        </el-col>
      </el-row> -->
    </el-form>

    <el-dialog v-if="addDialogFlag"
      :title="addDialogTitle"
      :visible.sync="addDialogFlag"
      width=98%
      top="1vh"
      center
      append-to-body>
          <!-- 弹出层 -->
          <!-- <Question v-if="addDialogPageType == 0"
              :initShowType="addDialogPageInfo.showType" :initQuestionId="addDialogPageInfo.questionId"
              :initQuestionName="addDialogPageInfo.questionName"
              @closeDialog="closeListDialog"
              :ifImport=1
              :ifChild=1
              :childIndex="addDialogPageInfo.childIndex"
              :parentQuestionInfo=questionInfo
          ></Question> -->
          <kw_look v-if="addDialogPageType == 0" :pageInfo="{
            pageId:(addDialogPageInfo.showType == 0?tablePageInfo.addPageId:tablePageInfo.updatePageId),
            tableId:pageInfo.tableId,
            listTableId:pageInfo.listTableId,
            mainId:addDialogPageInfo.questionId
          }" :initMainId="addDialogPageInfo.questionId" :parentQuestionInfo="{
            initShowType:addDialogPageInfo.showType,
            initQuestionId:addDialogPageInfo.questionId,
            initQuestionName:addDialogPageInfo.questionName,
            ifImport:1,
            ifChild:1,
            childIndex:addDialogPageInfo.childIndex,
            parentQuestionInfo:questionInfo
          }" @goBack="goBackChildQuestion"></kw_look>
          <!-- 试题附件设置页面 -->
          <QuestionFileSet v-model="questionInfo" v-if="addDialogPageType == 1" :showType="showType*1"></QuestionFileSet>
          <!-- 试题前置页面设置 -->
          <QuestionPrevSet v-model="questionInfo.prevSet" v-if="addDialogPageType == 2" :showType="showType*1"></QuestionPrevSet>
          <!-- 试题样式设置 -->
          <QuestionCssSet v-model="questionInfo.cssSet" v-if="addDialogPageType == 3" :showType="showType*1"></QuestionCssSet>
          <!-- 多题选择时的设置 -->
          <Question16 v-model="questionInfo" v-if="addDialogPageType == 4" :showType="showType*1"></Question16>
    </el-dialog>
  </div>
</template>

<script>

import $ from 'jquery'

import DoQuestion  from './DoQuestion.vue';
import AddOrUpPage  from '@/components/page/AddOrUpPage.vue';
import QuestionFileSet  from './QuestionFileSet.vue';
import QuestionPrevSet  from './QuestionPrevSet.vue';
import QuestionCssSet  from './QuestionCssSet.vue';
import Question16  from './Question16.vue';
import VueUeditorWrap from '@/components/vue-ueditor-wrap.vue';

export default {
  name: 'Question',
  props: {
    initShowType:Number,
    initQuestionId:Number,
    initQuestionInfo:Object,
    //初始的试题名称
    initQuestionName:String,
    //是否需要引入 修改页面
    ifImport:{
      type:Number,
      default:0
    },
    ifChild:{
      type:Number,
      default:0
    },
    childIndex:{
      type:Number,
      default:-1
    },
    //如果是子题 父级题的信息
    parentQuestionInfo:{
      type:Object,
      default:()=>{
        return {};
      }
    },
    pageInfo:{
      type:Object,
      default:null
    }
  },
  components: {
    DoQuestion,
    AddOrUpPage,
    QuestionFileSet,
    QuestionPrevSet,
    QuestionCssSet,
    Question16,
    'vue-ueditor-wrap':VueUeditorWrap,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  data() {
    return {
      //试题显示类型 添加:0  修改页面:1  预览页面:2   做题页面:3  批改页面:4  结果查看页面:5
      showType:0,
      questionId:0,
      //试题信息 包含题型等各种信息
      questionInfo:{
        eqType:1,
        eqAnswer:[],
        eqContent:"",
        eqOption:[],
        eqOption1:[],
        eqContentIfFile:1,
        eqAnswerIfFile:1,
        childQuestionArr:[],
        childQuestionScoreArr:[],
        //阅读题的段落个数
        sectionArr:[],
        //阅读题的插入框
        pointArr:[],
        //阅读题的高亮显示内容
        heigthArr:[]
      },
      //试题题目的提示信息
      eqContentTip:"单选题,必须填写选项和答案",
      //是否进行预览
      isPreview : false,
      //保存按钮的状态
      fullscreenLoading:false,

      //弹出层的打开状态
      addDialogFlag:false,
      //弹出层打开的内容类型
      addDialogPageType:0,
      //弹出层打开的弹出层的名称
      addDialogTitle:"选择层",
      //打开弹出层的页面信息
      addDialogPageInfo:{},

      //试题的接口页面的配置信息     
      //试题的接口页面的配置信息 百利数据 tableId:17971,importPageId:11704, addPageId:11637, updatePageId:11638 
      tablePageInfo:{},

      // crm 电子数据
      //tablePageInfo:{tableId:132,importPageId:820, addPageId:758,updatePageId:759 },
      /**
       * UEditor 简单版样式
       */
      UEditorSampleConfig:{
        toolbars: [['fullscreen', 'source', '|',
            'undo', 'redo', '|',
            'bold', 'italic', 'underline',
            'forecolor', 'backcolor',  '|',
            'paragraph', 'fontfamily', 'fontsize', '|'
            // ,'kityformula'
        ]]
      },
      /**
       * 编辑器的内容样式
       */
      editorOption: {
        theme: 'snow',
        placeholder: "输入任何内容，支持html",
        toolbar: {
          container: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{'header': 1}, {'header': 2}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'indent': '-1'}, {'indent': '+1'}],
            [{'direction': 'rtl'}],
            [{'size': ['small', false, 'large', 'huge']}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'color': []}, {'background': []}],
            [{'font': []}],
            [{'align': []}],
            [{'clean':'源码编辑'}],
            ['link', 'image', 'video']
          ]  // 工具栏选项
        }
      },
      /**
       * 长难句的选项类型
       */
      cnjAnswerType:[{
        DIC_ID : 1,
        DIC_NAME : '主语',
        btnName:'主语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 2,
        DIC_NAME : '谓语',
        btnName:'谓语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 3,
        DIC_NAME : '宾语',
        btnName:'宾语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 4,
        DIC_NAME : '定语',
        btnName:'定语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 5,
        DIC_NAME : '状语',
        btnName:'状语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 6,
        DIC_NAME : '补语',
        btnName:'补语',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 7,
        DIC_NAME : '形容词及其词组',
        btnName:'形容词及其词组',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 8,
        DIC_NAME : '副词及其词组',
        btnName:'副词及其词组',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 9,
        DIC_NAME : '非谓语动词',
        btnName:'非谓语动词',
        fnHandler: 'addCnjEqOption'
      },{
        DIC_ID : 10,
        DIC_NAME : '介词短语',
        btnName:'介词短语',
        fnHandler: 'addCnjEqOption'
      }],
      eqTypeList:[{
          DIC_ID : 1,
          DIC_NAME : '单选题',
          ifChild: 0
      }
      ,{
          DIC_ID : 2,
          DIC_NAME : '多选题',
          ifChild: 0
      },{
          DIC_ID : 3,
          DIC_NAME : '判断题',
          ifChild: 0
      },{
          DIC_ID : 4,
          DIC_NAME : '填空题',
          ifChild: 0
      },{
          DIC_ID : 7,
          DIC_NAME : '简答题',
          ifChild: 1
      },{
          DIC_ID : 8,
          DIC_NAME : '选择填空题',
          ifChild: 1
      },{
          DIC_ID : 9,
          DIC_NAME : '阅读题',
          ifChild: 0
      },
      // {
      //     DIC_ID : 10,
      //     DIC_NAME : '匹配题',
      //     ifChild: 0
      // },{
      //     DIC_ID : 14,
      //     DIC_NAME : '长难句',
      //     ifChild: 0
      // },
      {
          DIC_ID : 15,
          DIC_NAME : '插入填空',
          ifChild: 0
      }
      // ,{
      //     DIC_ID : 16,
      //     DIC_NAME : '多题选择',
      //     ifChild: 0
      // }
      ],
      eqContentIfFileList:[{
          DIC_ID : 1,
          DIC_NAME : '无附件'
      },{
          DIC_ID : 2,
          DIC_NAME : '上传附件'
      },{
          DIC_ID : 3,
          DIC_NAME : '录制附件'
      }],
      zmArr:["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      workTypeList:[{
          DIC_ID : 1,
          DIC_NAME : '默认'
      },{
          DIC_ID : 2,
          DIC_NAME : '托福阅读'
      },{
          DIC_ID : 3,
          DIC_NAME : '托福听力'
      },{
          DIC_ID : 4,
          DIC_NAME : '托福口语-独立口语'
      },{
          DIC_ID : 5,
          DIC_NAME : '托福口语-综合口语'
      },{
          DIC_ID : 6,
          DIC_NAME : '托福写作'
      }]
    };
  },
  created() {
    var that = this;
    //请求地址传递的参数
    var paramsJson = this.$route.params;
    var ifChild = this.ifChild;
    //判断是否有初始的试题显示类型 如果有则赋值给showType
    if(that.initShowType) {
      that.showType = that.initShowType;
    } else if(paramsJson.initShowType && ifChild == 0) {
      that.showType = paramsJson.initShowType;
    }
    if(that.initShowType == 2) {
      that.isPreview = true;
    }
    if(that.initQuestionId) {
      that.questionId = that.initQuestionId;
    } else if(paramsJson.initQuestionId && ifChild == 0) {
      that.questionId = paramsJson.initQuestionId;
    }
    //判断是否有初始的试题名称 如果有则进行默认赋值
    if(that.initQuestionName) {
      that.questionInfo.subjectName = that.initQuestionName;
    }
  },
  mounted() {
    var that = this;
    //判断试题的相关对象和页面ID是否存在 如果不存在则进行后台请求读取
    that.getSysSet();
    // that.zdyMounted();
  },
  methods: {
    /**
     * 获取系统设置信息
     */
    getSysSet(){
      var that = this;
      var url = "/model_getSysSet.do";
      var toHtData = {};
      toHtData.tableName = "XCX_SYS_SET";
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          var sysSetInfo = res.data.XCX_SYS_SET;
          var tablePageInfo = {};
          tablePageInfo.tableId = sysSetInfo.QUESTION_TABLE;
          tablePageInfo.importPageId = sysSetInfo.QUESTION_IMPORT_PAGE;
          tablePageInfo.addPageId = sysSetInfo.QUESTION_ADD_PAGE;
          tablePageInfo.updatePageId = sysSetInfo.QUESTION_UPDATE_PAGE;
          that.tablePageInfo = tablePageInfo;
          that.zdyMounted();
        } else {
          alert("没有获取到题库相关设置信息,请联系管理员");
        }
      }).catch(error => {
        console.log("=====" + error);
        alert("没有获取到题库相关设置信息,请联系管理员");
      })
    },
    /**
     *  页面初始化需要加载的内容
     */
    zdyMounted(){
      var that = this;
      //判断是否有试题信息 如果有赋值给questionInfo  如果没有则进行后台试题信息的加载 
      console.log("that.initQuestionInfo==============",that.initQuestionInfo);
      console.log("that.questionId==============",that.questionId);
      if(that.initQuestionInfo) {
        that.questionInfo = that.initQuestionInfo;
        that.updateLoad();
      } else if(that.questionId > 0 ) {
        //去后台请求本道试题的信息
        that.getQuestionInfo();
      } else {
        that.showType = 0;
        that.updateLoad();
      }
    },
    /**
     * 修改页面 试题内容加载后的方法
     */
    updateLoad(){
      var that = this;
      var questionInfo = this.questionInfo;
      var eqType = questionInfo.eqType;
      if(!this.questionInfo.prevSet) {
        this.$set(this.questionInfo, "prevSet", {});
      }
      if(!this.questionInfo.cssSet) {
        this.$set(this.questionInfo, "cssSet", {});
      }
      console.log("eqType============",eqType);
      if(eqType == 9) {
        that.getYdtSectionAndPoint(0);
      }
    },

    /**
     * 题型切换时 进行判断关联的设置
     */
    eqTypeChange(nowValue){
      var questionInfo = this.questionInfo;
      questionInfo.eqContentIfFile = 1;
      questionInfo.eqAnswerIfFile = 1;
      if(nowValue == 1) {
        //如果切换为单选题
        questionInfo.eqAnswer = "";
        this.eqContentTip="单选题,必须填写选项和答案";
      } else if(nowValue == 2) {
        //如果切换为多选题
        questionInfo.eqAnswer = [];
        this.eqContentTip="多选题,必须填写选项和答案,答案可多选";
      } else if(nowValue == 3) {
        questionInfo.eqOption = ["对","错"];
        this.eqContentTip="对错题,类似单选题,选项固定为对和错";
      } else if(nowValue == 4) {
        questionInfo.eqAnswer = [];
        this.eqContentTip="填空题,输入下划线自动代表一个填空内容。例如鲁迅，原名_______，我们学过他的散文有《________》、《________》，小说《________》。";
      } else if(nowValue == 7) {
        // 简单题
        questionInfo.eqAnswer = "";
      } else if(nowValue == 8) {
        // 选择填空题
        questionInfo.eqAnswer = [];
      } else if(nowValue == 9) {
        //阅读题
        questionInfo.childQuestionArr = [];
        questionInfo.childQuestionScoreArr = [];
        this.getYdtSectionAndPoint(0);
      } else if(nowValue == 10) {
        //匹配题
        questionInfo.eqOption = [];
        questionInfo.eqOption1 = [];
        questionInfo.eqAnswer = [];
      } else if(nowValue == 14) {
        //长难句
        questionInfo.eqAnswer = [];
        questionInfo.eqAnswer1 = [];
      } else if(nowValue == 15) {
        //如果是插入填空时,判断是否是阅读题的子题 如果是则 进行填空点的默认获取
        if(this.parentQuestionInfo && this.parentQuestionInfo.pointArr.length > 0) {
          questionInfo.eqOption = this.parentQuestionInfo.pointArr;
        }
      }
    },
    /**
     * 业务题型切换时 给试题的css设置 进行赋值
     */
    eqWorkTypeChange(nowValue){
//      综合口语和独立口语赋值准备时长和做题时长  托福口语-独立口语:nowValue(4)15 45  托福口语-综合口语:nowValue(5)30 60
      if(nowValue == 4){
        this.$set(this.questionInfo.prevSet, "preparatTime", 15);
        this.$set(this.questionInfo.prevSet, "recordTime", 45);
        this.questionInfo.eqType = 7;
      }
      if(nowValue == 5){
        this.$set(this.questionInfo.prevSet, "preparatTime", 20);
        this.$set(this.questionInfo.prevSet, "recordTime", 60);
        this.questionInfo.eqType = 7;
      }
      
      if(nowValue == 1) {
        this.questionInfo.cssSet = {
          cssType:"1",
          flexType:"1",
          dtkSet:"1",
          czlPosition:"1",
          ifConfirm:"2"
        }
      } else if(nowValue == 2) {//阅读题
        this.questionInfo.cssSet = {
          cssType:"2",
          flexType:"2",
          dtkSet:"2",
          czlPosition:"1",
          ifConfirm:"2"
        }
        this.questionInfo.eqType = 9;
      } else if(nowValue == 6) {//写作
        this.questionInfo.cssSet = {
          cssType:"2",
          flexType:"3",
          dtkSet:"2",
          czlPosition:"1",
          ifConfirm:"2"
        }
        this.questionInfo.eqType = 7;
      } else if(nowValue == 3) {//听力
        this.questionInfo.cssSet = {
           cssType:"2",
          flexType:"1",
          dtkSet:"2",
          czlPosition:"1",
          ifConfirm:"1"
        }
        this.questionInfo.eqType = 9;
      }  else {
        this.questionInfo.cssSet = {
          cssType:"2",
          flexType:"1",
          dtkSet:"2",
          czlPosition:"1",
          ifConfirm:"2"
        }
      }
      if(nowValue == 1) {
        this.questionInfo.ZD_DO_WAY = "2"; 
      } else {
        this.questionInfo.ZD_DO_WAY = "1"; 
      }
    },

    testChange(value){
      console.log("value============",value);
    },
    
    /**
     * 选中时 获取选中内容
     */
    eqContentSelect() {
      var questionInfo = this.questionInfo;
      if(questionInfo.eqType == 14) {
        //获取选中的文字 进行答案的增加
        event.preventDefault();
        var nowCheckText = this.GetSelectedText();
        if(nowCheckText) {
          this.questionInfo.eqOption.push("");
          this.questionInfo.eqAnswer.push(nowCheckText);
        } else {
          that.$message({
            showClose: true,
            message: "请选中内容后，点击鼠标右键",
            type: 'error'
          });
        }
      }
    },
    /**
     * 获取当前选中的内容
     */
    GetSelectedText() {
      var selText = "";
      if (window.getSelection) { // all browsers, except IE before version 9
          if (document.activeElement &&
              (document.activeElement.tagName.toLowerCase() == "textarea" ||
                  document.activeElement.tagName.toLowerCase() == "input")) {
              var text = document.activeElement.value;
              selText = text.substring(document.activeElement.selectionStart,
                  document.activeElement.selectionEnd);
          } else {
              var selRange = window.getSelection();
              selText = selRange.toString();
          }
      } else {
          if (document.selection.createRange) { // Internet Explorer
              var range = document.selection.createRange();
              selText = range.text;
          }
      }
      return selText;
    },
    /**
     * 获取试题题目有几个填空框 几个下划线组合
     */
    getEqContentFillNum(){
      var questionInfo = this.questionInfo;
      if(questionInfo.eqType == 4) {
        var eqContent = questionInfo.eqContent;
        var fillArr = eqContent.match(/__(_+)/ig);
        var prevEqAnswer = questionInfo.eqAnswer;
        questionInfo.eqAnswer = [];
        questionInfo.eqOption = [];
        console.log("fillArr========",fillArr);
        if(fillArr) {
          fillArr.forEach((element,index) => {
            var oneAnswer = (prevEqAnswer.length > index)?prevEqAnswer[index]:"";
            questionInfo.eqAnswer.push(oneAnswer);
            questionInfo.eqOption.push("");
          });
        }
      }

    },
    /**
     * 去后台请求试题信息
     */
    getQuestionInfo(){
      var that = this;
      //根据试题主键 questionId
      var questionId = this.questionId;
      var url = "/vueQuestion_getQuestionInfo.do";
      var toHtData = {};
      toHtData.questionId = questionId;
      this.$axios.post(url,toHtData).then(res => {
        if (res.data) {
          var questionInfo = res.data.question;
          if(!questionInfo.childQuestionArr) {
            questionInfo.childQuestionArr = [];
            questionInfo.childQuestionScoreArr = [];
          } else if(!questionInfo.childQuestionScoreArr) {
            questionInfo.childQuestionScoreArr = [];
            questionInfo.childQuestionArr.forEach(element => {
              questionInfo.childQuestionScoreArr.push(0);
            });
          }
          that.questionInfo = questionInfo;
          that.updateLoad();
        } else{
          //没有获取到试题信息 可以新增试题
          that.showType = 0;
          that.$message({
            showClose: true,
            message: "没有获取到试题信息 可以新增试题",
            type: 'error'
          });
        }
      }).catch(error => {
        console.log("=====" + error);
      })
    },
    /**
     * 添加一个选项题的选项
     */
    clickAddEqOption(){
      var questionInfo = this.questionInfo;
      questionInfo.eqOption.push("");
      //匹配题
      if(questionInfo.eqType == 10) {
        questionInfo.eqOption1.push("");
      }
    },
    /**
     * 删除一个选项
     */
    clickDeleteEqOption(index){
      var questionInfo = this.questionInfo;
      questionInfo.eqOption.splice(index,1);
      //如果是长难句
      if(questionInfo.eqType == 14) {
        questionInfo.eqAnswer.splice(index,1);
        questionInfo.eqAnswer1.splice(index,1);
      } else if(questionInfo.eqType == 10) {
        questionInfo.eqAnswer.splice(index,1);
        questionInfo.eqOption1.splice(index,1);
      }
    },

    /**
     * 根据文件名称获取文件类型
     */
    getFileTypeByName(name) {
      var fileType = 'image';
      if(name.indexOf(".jpg") > 0 || name.indexOf(".png") > 0) {
        fileType = "image";
      } else if(name.indexOf(".mp4") > 0 || name.indexOf(".m3u8") > 0 || name.indexOf(".flv") > 0) {
        fileType = "video";
      } else if(name.indexOf(".mp3") > 0) {
        fileType = "audio";
      }
      return fileType;
    },
    /**
     * 录制音频结束时 进行题目附件的绑定
     */
    setEqContentFile:function(audioSrc) {
      this.questionInfo.eqContentFile = audioSrc;
    },
    /**
     * 录制音频结束时 进行答案附件的绑定
     */
    setEqAnswerFile:function(audioSrc) {
      this.questionInfo.eqAnswerFile = audioSrc;
    },
    /**
     * 文件上传成功时的处理函数
     */
    successFile:function(response, file, fileList, type){
      var that = this;
      var arr = response.split(":");
      var downAddress = arr[0];
      var fileId = arr[1];
      file.fileId = fileId;
      file.downAddress = downAddress;
      var toHtId = "";
      fileList.forEach(element => {
          if(element.status == "success") {
              if(toHtId!="") {
                  toHtId+=","
              }
              toHtId+=element.fileId;
          }
          var name = element.name;
          element.fileType = that.getFileTypeByName(name);
      });
      if(type == 0) {
        this.questionInfo.eqContentFileId = toHtId;
        this.questionInfo.eqContentFile = fileList;
      } else {
        this.questionInfo.eqAnswerFileId = toHtId;
        this.questionInfo.eqAnswerFile = fileList;
      }
    },
    /**
     * 文件删除时的处理函数
     */
    removeFile:function(file, fileList,fieldSetOne,type){
      var that = this;
      var toHtId = "";
      fileList.forEach(element => {
          if(element.status == "success") {
              if(toHtId!="") {
                  toHtId+=","
              }
              toHtId+=element.fileId;
          }
          var name = element.name;
          element.fileType = that.getFileTypeByName(name);
      });
      if(type == 0) {
        this.questionInfo.eqContentFileId = toHtId;
        this.questionInfo.eqContentFile = fileList;
      } else {
        this.questionInfo.eqAnswerFileId = toHtId;
        this.questionInfo.eqAnswerFile = fileList;
      }
    },
    /**
     * 文件上传个数超出时进行提醒
     */
    exceedFile:function(files, fileList) {
      this.$message({
          message: '最大文件上传个数为:'+5+",不可超出!",
          type: 'warning'
      });
    },
    /**
     * 阅读题增加试题
     *
     */
    clickAddQuestion:function(){
      //判断类型
      this.addDialogPageType = 0;
      //获取需要打开的页面信息
      var addDialogPageInfo = {
        showType:0,questionId:0,
        questionName:"阅读题子题_"+(this.questionInfo.childQuestionArr.length+1),
        childIndex:-1
      };

      this.addDialogPageInfo = addDialogPageInfo;
      console.log("this.addDialogPageInfo===========",this.addDialogPageInfo);
      
      //打开弹出层 进行数据加载
      this.addDialogFlag = true;
    },
    clickUpdateQuestion:function(childQuestionIndex){
      var questionInfo = this.questionInfo;
      var updateQuestionId = questionInfo.childQuestionArr[childQuestionIndex];
      //判断类型
      this.addDialogPageType = 0;
      //获取需要打开的页面信息
      var addDialogPageInfo = {
        showType:1,questionId:updateQuestionId*1,
        questionName:"阅读题子题_"+(this.questionInfo.childQuestionArr.length+1),
        childIndex:childQuestionIndex
      };

      this.addDialogPageInfo = addDialogPageInfo;
      console.log("this.addDialogPageInfo===========",this.addDialogPageInfo);
      
      //打开弹出层 进行数据加载
      this.addDialogFlag = true;
    },
    //子试题添加后 
    goBackChildQuestion:function(type,dataInfo){
      var childId = 0;
      if(dataInfo) {
        childId = dataInfo.mainId;
      }
      this.closeListDialog(childId);
    },
    /**
     * 弹出层选择数据后 点击确定时 进行赋值和弹出层关闭
     */
    closeListDialog:function(newQuestionId,questionIndex){
        if(!questionIndex) {
          questionIndex = this.addDialogPageInfo.childIndex;
        }
        //获取弹出层中的试题主键信息
        // var newQuestionInfo = {};
        // newQuestionInfo.questionId = newQuestionId;
        // newQuestionInfo.showType = 2;
        if(newQuestionId > 0) {
          if(questionIndex == -1) {
            this.questionInfo.childQuestionArr.push(newQuestionId);
            this.questionInfo.childQuestionScoreArr.push("");
          } else {
            this.questionInfo.childQuestionArr[questionIndex] = newQuestionId;
          }
        }
        console.log("childQuestionArr========",this.questionInfo.childQuestionArr);

        //关闭弹出层
        this.addDialogFlag = false;
        this.addDialogPageInfo ={};
    },
    /**
     * 删除阅读题的子试题
     */
    clickDeleteQuestion:function(childQuestionIndex) {
      var questionInfo = this.questionInfo;
      questionInfo.childQuestionArr.splice(childQuestionIndex,1);
      questionInfo.childQuestionScoreArr.splice(childQuestionIndex,1);
      console.log("questionInfo.childQuestionScoreArr=====================",questionInfo.childQuestionScoreArr);
    },
    /**
     * 保存时验证 填写规则是否已填写
     */
    checkQuestion(callback){
      var that = this;
      var resultCheckArr = [];
      if(that.$refs.questionImport) {
        that.$refs.questionImport.getCheckFormArr();
        resultCheckArr = that.$refs.questionImport.tmpResultCheckArr;
      }
      var resultOne = that.$refs.questionForm.validate();
      resultCheckArr.push(resultOne);
      Promise.all(resultCheckArr).then(function() { //都通过了
        console.log('恭喜你，表单全部验证通过啦')
        that.saveQuestion(callback);
      }).catch(function() {
          console.log("验证之后的catch,不知道干什么的");
      });
    },
    /**
     * 保存试题
     */
    saveQuestion(callback){
      //判断试题是添加还是修改功能
      var that = this;
      //根据试题主键 questionId
      var questionId = this.questionId;
      var showType = this.showType;
      var questionInfo = this.questionInfo;
      var url = "/vueQuestion_saveQuestion.do";
      console.log(this.loginForm);
      this.fullscreenLoading = true;
      var toHtData = {};
      toHtData.questionId = questionId;
      toHtData.mainDataId = questionId;
      toHtData.showType = showType;
      toHtData.tableId = this.tablePageInfo.tableId;
      if(showType == 0) {
        toHtData.pageId = this.tablePageInfo.addPageId;
      } else {
        toHtData.pageId = this.tablePageInfo.updatePageId;
      }
      toHtData.isInterFace=1;
      var eqContentFileAddress = [];
      var eqAnswerFileAddress = [];
      var eqContentFileType = [];
      var eqAnswerFileType = [];
      var eqContentFileSetInfo = [];
      
      for (var key in questionInfo) {
        //如果是简答题 保存题目附件和答案附件
        if(key == "eqContentFile") {
          //题目附件
          var eqContentFile = questionInfo[key];
          if(eqContentFile) {
            eqContentFile.forEach(element => {
              eqContentFileAddress.push(element.downAddress);
              eqContentFileType.push(element.fileType);
              eqContentFileSetInfo.push(JSON.stringify(element));
            });
          }
        } else if(key == "eqAnswerFile"){
          //答案附件
          var eqAnswerFile = questionInfo[key];
          if(eqAnswerFile) {
            eqAnswerFile.forEach(element => {
              eqAnswerFileAddress.push(element.downAddress);
              eqAnswerFileType.push(element.fileType);
            });
          }
        } else if(key == "childQuestionScoreArr"){
          //如果是阅读题则进行试题分数的计算
          var tmpScore = 0;
          if(questionInfo[key].length > 0) {
            var childScoreConcat = "";
            questionInfo[key].forEach(element => {
              tmpScore += element*1;
              childScoreConcat += (childScoreConcat!=""?",":"") + element;
            });
            toHtData.eqScore = tmpScore;
            toHtData.childScoreConcat = childScoreConcat;
          }
          toHtData[key] = questionInfo[key];
        } else if(key == "prevSet") {
          toHtData[key] = JSON.stringify(questionInfo[key]);
        } else if(key == "cssSet") {
          toHtData[key] = JSON.stringify(questionInfo[key]);
        }  else if(key.startsWith("eqOtherInfo_")) {
          toHtData[key] = JSON.stringify(questionInfo[key]);
        } else {
          toHtData[key] = questionInfo[key];
        }
      }
      // 长难句类型的 进行eqAnswer1的转换
      if(toHtData.eqAnswer1) {
        for (let index = 0; index < toHtData.eqAnswer1.length; index++) {
          const element = toHtData.eqAnswer1[index];
          if(element == null) {
            toHtData.eqAnswer1[index] = "";
          }
        }
      }
      //获取引入页面的 需要传递到后台保存的信息
      if(that.$refs.questionImport) {
        that.$refs.questionImport.getChildToHtData();
        var importData = that.$refs.questionImport.allToHtData;
        if(importData) {
          for(var key in importData) {
            toHtData[key] = importData[key];
          }
        }
      }
      //传递到后台是否是子题进行保存
      if(that.ifChild == 0) {
        toHtData.ifChild = 2;
      } else {
        toHtData.ifChild = 1;
      }
      //子题主键传递到后台
      var childQuestionArr = questionInfo.childQuestionArr;
      if(childQuestionArr != null && childQuestionArr.length > 0) {
        var childIdConcat = "";
        for (let index = 0; index < childQuestionArr.length; index++) {
          if(index != 0) {
            childIdConcat += ",";
          }
          childIdConcat += childQuestionArr[index];
        }
        toHtData.childIdConcat = childIdConcat;
      }
      toHtData.eqContentFileAddress = eqContentFileAddress;
      toHtData.eqAnswerFileAddress = eqAnswerFileAddress;
      toHtData.eqContentFileType = eqContentFileType;
      toHtData.eqAnswerFileType = eqAnswerFileType;
      toHtData.eqContentFileSetInfo = eqContentFileSetInfo;
      console.log("toHtData======================",toHtData);
      this.$axios.post(url,toHtData).then(res => {
        that.fullscreenLoading = false;
        console.log("data===================",res.data);
        if(res.data) {
          that.$message({
            showClose: true,
            message: "保存成功!",
            type: 'success'
          });
          that.questionId = res.data.mongoEqId;
          questionInfo.mongoEqId = res.data.mongoEqId;
          questionInfo.mongoId = res.data.mongoId;
          questionInfo.ifChild = toHtData.ifChild;
          questionInfo.childIdConcat = toHtData.childIdConcat;
          questionInfo.childScoreConcat = toHtData.childScoreConcat;
          // that.cancelPage();
          if(callback) { 
            //题型  业务题型 做题形式 主键
            callback(questionInfo);
          }
        } else {
          that.$message({
            showClose: true,
            message: "保存失败,请重试!",
            type: 'error'
          });
        }
      }).catch(error => {
        console.log("=====" + error);
      })
    },
    /**
     * 切换预览和编辑状态
     */
    changePreview() {
      this.isPreview = !this.isPreview;
    },
    /**
     * 返回上一步页面
     */
    cancelPage() {
      //如果是路由调用 则返回页面 如果是组件调用则调用回调函数
      console.log("this.questionId===============",this.questionId);

      if(this.initShowType >= 0) {
        this.$emit("closeDialog",this.questionId,this.childIndex);
      } else {
        //window.location.href=document.referrer;
        window.parent.$('#make-mainPage-tab').omTabs('close');
      }
    },

    /**
     * ueditor 内容切换时触发
     */
    ueditorSelectionChange(editor){
      var that = this;
      editor.addListener( 'contentChange', function( editor ) {
          var questionInfo = that.questionInfo;
          if(questionInfo.eqType == 4) {
            var myTextEditor = that.$refs.myTextEditor;
            var eqContent = questionInfo.eqContent;
            if(eqContent.indexOf("_") > 0) {
              eqContent = eqContent.replace(/_+/ig,"________");
              questionInfo.eqContent = eqContent;
              myTextEditor.editor.focus(true);
            }
            that.getEqContentFillNum();
            console.log('选区发生改变：',eqContent);
          }
      })
    },
    // 添加自定义按钮
    addCustomButtom (editorId) {
      var that = this;
      window.UE.registerUI('section height point', function (editor, uiName) {
        // 注册按钮执行时的 command 命令，使用命令默认就会带有回退操作
        editor.registerCommand(uiName, {
          execCommand: function () {
            var questionInfo = that.questionInfo;
            var myTextEditor = that.$refs.myTextEditor;
            console.log("uiName====================",uiName,questionInfo);
            if(uiName=='section') {
              that.getYdtSectionAndPoint(1);
              var nowLength = questionInfo.sectionArr.length;
              //段落标识
              editor.execCommand('inserthtml', "<span aType='1' style='background-color: gray;'> " + (nowLength+1) + " </span>");
              questionInfo.sectionArr.push((nowLength+1)+"");
            } else if(uiName=='height') {
              //获取选中文本 替换为span 带背景及颜色样式的
              var range = myTextEditor.editor.selection.getRange();
              range.select();
              var checkText = myTextEditor.editor.selection.getText();
              console.log("checkText==================",checkText);
              that.getYdtSectionAndPoint(3);
              //高亮显示
              editor.execCommand('inserthtml', "<span aType='3' style='background-color: gray;'>" + checkText + "</span>");
              questionInfo.heigthArr.push(checkText);
            } else {
              that.getYdtSectionAndPoint(2);
              var nowLength = questionInfo.pointArr.length;
              //插入点
              editor.execCommand('inserthtml', "<span aType='2' style='background-color: gray;color:white;'>   </span>");
              questionInfo.pointArr.push((nowLength+1)+"");
            }
          }
        });

        // 创建一个 button
        var btn = new window.UE.ui.Button({
          // 按钮的名字
          name: uiName,
          // 提示
          title: (uiName=='section'?"段落标识":(uiName=='height'?"高亮显示":"插入点")),
          // 需要添加的额外样式，可指定 icon 图标，图标路径参考常见问题 2
          cssRules: 'background-position: -500px 0;',
          // 点击时执行的命令
          onclick: function () {
            // 这里可以不用执行命令，做你自己的操作也可
            editor.execCommand(uiName);
          }
        });

        // 因为你是添加 button，所以需要返回这个 button
        return btn;
      }, 0 /* 指定添加到工具栏上的哪个位置，默认时追加到最后 */, editorId /* 指定这个 UI 是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */);
    },
    /**
     * 获取阅读题和子题的 段落和插入点标识
     */
    getYdtSectionAndPoint(type){
      var that = this;
      var questionInfo = that.questionInfo;
      //var myTextEditor = that.$refs.myTextEditor;
      var contentText = questionInfo.eqContent;//myTextEditor.editor.getContent();
      console.log("contentText======================",contentText);
      var spanArr = $(contentText).find("span");
      console.log(spanArr.length);
      var sectionArr = [];
      var pointArr = [];
      var heigthArr = [];
      for (let index = 0; index < spanArr.length; index++) {
        const spanOne = spanArr[index];
        //判断是段落 还是插入点
        var aType = $(spanOne).attr("aType");
        if(aType == 2) {
          pointArr.push((pointArr.length + 1)+"");
        } else if(aType == 1) {
          sectionArr.push((sectionArr.length + 1)+"");
        } else if(aType == 3) {
          heigthArr.push($(spanOne).text());
        } 
      }
      if(type == 1 || type == 0) {
        questionInfo.sectionArr = sectionArr;
      }
      if(type == 2 || type == 0) {
        questionInfo.pointArr = pointArr;
      }
      if(type == 3 || type == 0) {
        questionInfo.heigthArr = heigthArr;
      }
    },
    /**
     * 打开试题设置的弹出层
     */
    openSetDialog(type){
      //打开弹出层 进行数据加载
      this.addDialogPageType = type;
      this.addDialogFlag = true;
    },
    /**
     * 上移 下移 子题
     */
    upDownChildQuestion(index,type) {
      var questionInfo = this.questionInfo;
      var childQuestionArr = questionInfo.childQuestionArr;
      var childQuestionScoreArr = questionInfo.childQuestionScoreArr;
      //上移
      if(type == 1) {
        if(index!=0){
          childQuestionArr[index] = childQuestionArr.splice(index-1, 1, childQuestionArr[index])[0];
          childQuestionScoreArr[index] = childQuestionScoreArr.splice(index-1, 1, childQuestionScoreArr[index])[0];
        }else{
          childQuestionArr.push(childQuestionArr.shift());
          childQuestionScoreArr.push(childQuestionScoreArr.shift());
        }
      } else if(type == 2) {
        //下移
        if(index!=childQuestionArr.length-1){
          childQuestionArr[index] = childQuestionArr.splice(index+1, 1, childQuestionArr[index])[0];
          childQuestionScoreArr[index] = childQuestionScoreArr.splice(index+1, 1, childQuestionScoreArr[index])[0];
        }else{
          childQuestionArr.unshift( childQuestionArr.splice(index,1)[0]);
          childQuestionScoreArr.unshift( childQuestionScoreArr.splice(index,1)[0]);
        }
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 子表格的DIV增加边框样式 */
.childTableDiv{border-bottom:1px dashed #000;margin-top: 15px;}
/* form表单的元素增加宽度 */
.form_item_class{
    width:100%;
}
/* 添加修改页面的input的样式 宽度 */
.add_or_up_input{
    width:190px;
}
.BtnBox{text-align: center;}
.BtnBox button{margin: 10px; padding-left: 3em; padding-right: 3em;}
.BtnBox .close{}

.quill-editor {
  border: 1px solid #ccc;
}
</style>